// extracted by mini-css-extract-plugin
export var container = "_8p-1";
export var cornerButtonContainer = "_8p-5";
export var disabled = "_8p-2";
export var fileContainer = "_8p-4";
export var hiddenInput = "_8p-3";
export var widthContainer = "_8p-0";